export default "__VITE_ASSET__Uxa$dRTP__";